import styled, { css } from 'styled-components';

export const FromIdeaImageSliderContainer = styled.div`
  display: grid;
  position: relative;
`;

const activeStyles = css`
  opacity: 1;
`;

const hiddenStyles = css`
  opacity: 0;
`;

export const FromIdeaImage = styled.div<{ state: 'active' | 'hidden' }>`
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  align-self: center;
  justify-self: center;
  transition: opacity 500ms ease-in-out;

  ${({ state }) => (state === 'active' ? activeStyles : hiddenStyles)}
`;

